export const __loaderInnerWrap = ({ centerAt }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	extend: [
		{
			condition: centerAt === 'inherited',
			style: {
				height: '100%',
				width: '100%',
			},
		},
		{
			condition: centerAt === 'fixed',
			style: {
				position: 'fixed',
				top: '0px',
				left: '0px',
				height: '100vh',
				width: '100%',
			},
		},
	],
})
